import { defineStore } from 'pinia'

export const useCarStore = defineStore({
    id: 'car',
    state: () => ({
        cars: [],
        mapped: {},
        filteredCars: [],
        filters:[],
        settings: [],
        dtcActive: false,
        locations: [],
        locationemployees: [],
        employees: [],
        sections: [],
        callToActions: [],
        contact: [],
        filterOptions: [],
        fieldOptions: [],
        car: {},
        loading: false,
        error: null
    }),
    getters: {
        async getCars() {
            if(this.cars.length === 0)
                return await this.fetchCars();
            else
                return this.cars
        }
    },
    actions: {
        setCar(car) {
            this.car = car;
        },
        toggleFavorite(carid) {
            var favorites = localStorage.getItem('favorites')
            if(favorites !== null)
            {
                favorites = JSON.parse(favorites)
                if(favorites.filter(x => x == carid).length > 0)
                {
                    //remove
                    var index = favorites.indexOf(carid);
                    if (index >= 0) {
                        favorites.splice( index, 1 );
                    }
                }
                else {
                    favorites.push(carid);
                }
                localStorage.setItem('favorites',JSON.stringify(favorites))
            }
            else {
                favorites = [];
                favorites.push(carid);
                localStorage.setItem('favorites',JSON.stringify(favorites))
            }
        },
        getFavorites()
        {
            var favorites = localStorage.getItem('favorites')
            if(favorites !== null)
            {
                favorites = JSON.parse(favorites)
                var favs = this.cars.filter(x => Object.values(favorites).includes(x.mappeddata.carid));
                const uniqueArray = favs.reduce((accumulator, current) => {
                    if (!accumulator.find((item) => item.id === current.id)) {
                        accumulator.push(current);
                    }
                    return accumulator;
                }, []);
                return uniqueArray
            }
            else {
                favorites = []
            }
            return favorites;
        },
        async fetchCars() {
            if(this.cars.length > 0)
                return this.cars;

            this.filteredCars = [];
            this.loading = true
            var _this = this;

            try {
                var url = window.crcApiUrl;
                if(url === undefined || url === null)
                    url = 'https://crc.test/api/vue-endpoint/';

                return await fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        _this.filters = data.filter_options;
                        _this.cars = []

                        _this.filters.sort(function(a,b) {
                            if(b.key === 'merk' && a.key !== 'nieuw')
                                return 1;
                            if(b.key === 'nieuw')
                                return 1;
                            if(b.key === 'model')
                                return 1;
                            return -1;
                        });

                        _this.filters.forEach(function(obj) {
                            if(obj.type === "minmax")
                            {
                                obj.options.forEach(function(o){
                                    o.title = parseInt(o.title)
                                })
                            }
                            else {
                              obj.options.forEach(function(o) {
                                  o.title = o.title.replace("Škoda","Skoda")
                              })
                            }

                            obj.options.sort((a, b) => (a.title > b.title)  ? 1 : -1)
                            if(obj.type !== "minmax")
                            obj.options.forEach(function(o) {
                                o.title = o.title.replace("Skoda","Škoda")
                            })
                        });

                        // Only add cars which have a photo
                        data.cars.forEach(function(car) {
                            if (car.photos.length > 0) {
                                _this.cars.push(car);
                                _this.filteredCars.push(car);
                            }
                        })
                        _this.sections = [];
                        data.sections.forEach(function(section) {
                            _this.sections.push(section.key);
                        })

                        if(_this.filters.filter(x => x.key === "merk").length > 0)
                        {
                            var modelfilter = _this.filters.filter(x => x.key === "merk")[0];
                            var hondaObj = modelfilter.options.filter(x => x.title === "Honda")[0];
                            if(hondaObj)
                            {
                                var hondaindex = modelfilter.options.findIndex(x => x.title === "Honda")
                                modelfilter.options.splice(hondaindex,1)
                                modelfilter.options.unshift(hondaObj)
                            }
                        }


                        // Set additional data
                        this.mapped = data.mapped_fields
                        this.contact = data.contact
                        this.settings = data.settings
                        this.employees = data.employees
                        this.locations = data.locations
                        this.locationemployees = data.employees_by_location
                        this.callToActions = data.callToActions
                        this.filterOptions = _this.filters
                        this.fieldOptions = data.field_options
                        _this.cars.sort((a, b) => a.id < b.id);
                        _this.dtcActive = data.settings.dtc_active;

                        return _this.cars
                    })
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        }
    }
})
